  if (window.matchMedia("(max-width: 768px)").matches) {
function initStickyBar() {
  const placeholder = document.querySelector('.atc-placeholder');
  const productForm = document.querySelector('.product-form');

  if (!placeholder || !productForm) return;

  const minDistance = 400;
  const buffer = 50; // Prevent vibration
  let isSticky = false;
  let triggerOffset = productForm.offsetTop + productForm.offsetHeight;

  function updateSticky() {
    const scrollTop = window.scrollY || window.pageYOffset;

    if (scrollTop > triggerOffset - window.innerHeight + minDistance + buffer && !isSticky) {
      placeholder.classList.add('mar-sticky-bar');
      isSticky = true;
    } else if (scrollTop < triggerOffset - window.innerHeight + minDistance - buffer && isSticky) {
      placeholder.classList.remove('mar-sticky-bar');
      isSticky = false;
    }
  }

  function recalcOffset() {
    triggerOffset = productForm.offsetTop + productForm.offsetHeight;
    updateSticky();
  }

  window.addEventListener('scroll', updateSticky);
  window.addEventListener('resize', recalcOffset);
  window.addEventListener('orientationchange', recalcOffset);
  window.addEventListener('load', recalcOffset);

  // Initial check
  updateSticky();
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initStickyBar);

// Re-initialize on Shopify AJAX product updates or section loads
document.addEventListener('theme:section:load', initStickyBar);
document.addEventListener('product:updated', initStickyBar);
document.addEventListener('page:load', initStickyBar);
  }



 if (window.matchMedia("(min-width: 769px)").matches) {
function initStickyBar() {
  const placeholder = document.querySelector('.atc-placeholder');
  const productForm = document.querySelector('.product-form');

  if (!placeholder || !productForm) return;

  const minDistance = 800;
  const buffer = 50; // Prevent vibration
  let isSticky = false;
  let triggerOffset = productForm.offsetTop + productForm.offsetHeight;

  function updateSticky() {
    const scrollTop = window.scrollY || window.pageYOffset;

    if (scrollTop > triggerOffset - window.innerHeight + minDistance + buffer && !isSticky) {
      placeholder.classList.add('mar-sticky-bar');
      isSticky = true;
    } else if (scrollTop < triggerOffset - window.innerHeight + minDistance - buffer && isSticky) {
      placeholder.classList.remove('mar-sticky-bar');
      isSticky = false;
    }
  }

  function recalcOffset() {
    triggerOffset = productForm.offsetTop + productForm.offsetHeight;
    updateSticky();
  }

  window.addEventListener('scroll', updateSticky);
  window.addEventListener('resize', recalcOffset);
  window.addEventListener('orientationchange', recalcOffset);
  window.addEventListener('load', recalcOffset);

  // Initial check
  updateSticky();
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initStickyBar);

// Re-initialize on Shopify AJAX product updates or section loads
document.addEventListener('theme:section:load', initStickyBar);
document.addEventListener('product:updated', initStickyBar);
document.addEventListener('page:load', initStickyBar);
  }
